module.exports = __webpack_public_path__ + "media/icons/error--red-circle-bg-0fb2ae12.svg";